import React from "react"
import {
  Col,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Image,
  Row,
  Select,
  Tabs,
  TimePicker,
} from "antd"
import { Button } from "src/components/actions/button"
import { CloseSvg, RotateClockwiseSvg, SaveSvg } from "src/components/Svg"
import { useAppData } from "src/store/app-data"
import {getInitialValues, validateSecondsIsZero} from "src/utils/helpers"
import styled from "styled-components"
import moment from "moment"
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons"

const DEFAULT_INTERVAL = {
  start: null,
  end: null,
}

export function EditDrawer({
                             title,
                             initialValues,
                             onClose,
                             onSave,
                             pointOptions,
                             loading
                           }) {
  const layoutConfig = useAppData((state) => state.layoutConfig)

  const [form] = Form.useForm()

  console.log(initialValues)

  const getDefaultFormValues = React.useCallback(() => {
    if (initialValues) {
      const values = getInitialValues(initialValues)

      return {
        ...values,
        intervals:
            values?.intervals?.length > 0
                ? values.intervals
                : [DEFAULT_INTERVAL],
      }
    }

    return {
      intervals: [DEFAULT_INTERVAL],
    }
  }, [initialValues])

  React.useEffect(() => {
    form.setFieldsValue(getDefaultFormValues())
  }, [form, getDefaultFormValues])

  function prepareData(values) {
    const id = initialValues?.id

    const data = {
      ...(id && { id, _method: "PUT" }),
      date: moment(values.date).format("YYYY-MM-DD"),
      pointIds: values.pointIds,
      intervals: (values.intervals || []).map((item) => ({
        start: item?.start ? moment(item.start).format("HH:mm") : null,
        end: item?.end ? moment(item.end).format("HH:mm") : null,
      })),
    }

    return data
  }

  async function onSubmit(values) {
    const baseData = prepareData(values)

    try {
      await onSave(baseData, initialValues?.id)

      onClose()
      form.resetFields()
      form.setFieldsValue({
        intervals: [DEFAULT_INTERVAL],
      })
    } catch (error) {
      console.warn("error save sattings")
    }
  }

  function selectAllPoints() {
    const all = pointOptions.map((item) => item.value)
    form.setFieldValue("pointIds", all)
  }

  function handleClose() {
    onClose()
    form.resetFields()
    form.setFieldsValue({
      intervals: [DEFAULT_INTERVAL],
    })
  }

  const id = initialValues?.id ?? "new"
  // Сегодня оставляем доступным: чаще всего дату закрывают день в день,
  // когда на точке что-то сломалось.
  const disablePast = (current) =>
    current && current < moment().startOf("day")

  return (
      <DrawerEdit
          width={layoutConfig.isMobile ? "90%" : "80%"}
          title={title}
          onClose={handleClose}
          open
      >
        <FormEdit
            form={form}
            layout={"vertical"}
            onFinish={(values) => onSubmit(values)}
        >
          <StyledFormItem
              key={id + "_date"}
              label={"Дата"}
              name={"date"}
              rules={[
                {
                  required: true,
                  message: "Выберите дату!",
                },
              ]}
          >
            <DatePicker
                style={{
                  width: "100%",
                }}
                placeholder={"Выберите дату"}
                disabledDate={disablePast}
            />
          </StyledFormItem>

          <StyledFormItem
              key={id + "_pointIds"}
              label={"Точки (несколько)"}
              name={"pointIds"}
              rules={[
                {
                  required: true,
                  message: "Выберите точки!",
                },
              ]}
          >
            <Select mode="multiple" options={pointOptions} />
          </StyledFormItem>

          <Button
              type="dashed"
              onClick={selectAllPoints}
              style={{ marginBottom: "20px" }}
          >
            выбрать все точки
          </Button>

          <Divider orientation="left">Интервалы для презаказа</Divider>

          <Form.List
              name="intervals"
              initialValue={[DEFAULT_INTERVAL]}
              rules={[
                {
                  validator: async (_, value) => {
                    if (!value || value.length < 1) {
                      throw new Error("Должен быть хотя бы один интервал")
                    }
                  },
                },
              ]}
          >
            {(fields, { add, remove }, { errors }) => (
                <>
                  <Row gutter={[24, 16]} style={{ marginBottom: "16px" }}>
                    {fields.map(({ key, name, ...field }, index) => (
                        <Col
                            className="gutter-row"
                            key={`preorderIntervals_${key}`}
                            span={3}
                        >
                          <StyledFormItem
                              label={"Начало"}
                              key={`intervalsStart_${index}`}
                              name={[name, "start"]}
                              {...field}
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите начало",
                                },
                                { validator: validateSecondsIsZero }
                              ]}
                          >
                            <TimePicker
                                style={{ width: "100%" }}
                                format="HH:mm:ss"
                            />
                          </StyledFormItem>

                          <StyledFormItem
                              label={"Конец"}
                              key={`intervalsEnd_${index}`}
                              name={[name, "end"]}
                              {...field}
                              rules={[
                                {
                                  required: true,
                                  message: "Укажите конец",
                                },
                                { validator: validateSecondsIsZero }
                              ]}
                          >
                            <TimePicker
                                style={{ width: "100%" }}
                                format="HH:mm:ss"
                            />
                          </StyledFormItem>

                          {fields.length > 1 ? (
                              <Button
                                  danger
                                  onClick={() => remove(name)}
                                  style={{ width: "100%" }}
                                  icon={<MinusCircleOutlined />}
                              >
                                Удалить
                              </Button>
                          ) : null}
                        </Col>
                    ))}
                  </Row>

                  <Form.ErrorList errors={errors} />

                  <StyledFormItem>
                    <Button
                        type="dashed"
                        onClick={() => add(DEFAULT_INTERVAL)}
                        style={{ width: "100%" }}
                        icon={<PlusOutlined />}
                    >
                      Добавить интервал
                    </Button>
                  </StyledFormItem>
                </>
            )}
          </Form.List>

          <ButtonRow>
            <ButtonCol>
              <Button
                  danger
                  onClick={() => {
                    form.setFieldsValue(getDefaultFormValues())
                  }}
                  icon={<RotateClockwiseSvg />}
              >
                Вернуть
              </Button>
            </ButtonCol>

            <ButtonCol>
              <Button onClick={handleClose} icon={<CloseSvg />}>
                Закрыть
              </Button>
            </ButtonCol>

            <ButtonCol>
              <Button
                  icon={<SaveSvg />}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  disabled={loading}
              >
                Сохранить
              </Button>
            </ButtonCol>
          </ButtonRow>
        </FormEdit>
      </DrawerEdit>
  )
}

const DrawerEdit = styled(Drawer)``

const FormEdit = styled(Form)``

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`

const ButtonCol = styled(Col)`
  padding-bottom: 5px;
`

const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  .ant-col {
    margin-left: 0.4em;
  }
`